import { ReducerCreators } from '@reduxjs/toolkit';
import { AudiencesState } from '../types';
import { GetPasscodeLists } from '@/connection/audiences/passcode-lists';
import type { RootState } from '@/store/root-state';

export const fetchPasscodeLists = (create: ReducerCreators<AudiencesState>) =>
  create.asyncThunk(
    async (channel: number) => {
      return await GetPasscodeLists(channel);
    },
    {
      options: {
        condition: (_, { getState }) => {
          const state = getState() as RootState;
          return !state.audiences.loadingPasscodeLists;
        },
      },
      fulfilled: (state, action) => {
        if (action.payload) {
          state.passcodeLists = action.payload || [];
        }
        state.loadingPasscodeLists = false;
      },
      pending: (state) => {
        state.loadingPasscodeLists = true;
      },
      rejected: (state, action) => {
        state.loadingPasscodeLists = false;
        console.error(action.error);
      },
    }
  );
